/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../compat/compat-navigation.component';
const styles_CompatNavigationComponent:any[] = ([] as any[]);
export const RenderType_CompatNavigationComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CompatNavigationComponent,
  data: {}
}
);
export function View_CompatNavigationComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
function View_CompatNavigationComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-compat-navigation',([] as any[]),(null as any),(null as any),(null as any),View_CompatNavigationComponent_0,RenderType_CompatNavigationComponent)),
    import0.ɵdid(49152,(null as any),0,import1.CompatNavigationComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const CompatNavigationComponentNgFactory:import0.ComponentFactory<import1.CompatNavigationComponent> = import0.ɵccf('app-compat-navigation',import1.CompatNavigationComponent,View_CompatNavigationComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC1uYXZpZ2F0aW9uLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2NvbXBhdC9jb21wYXQtbmF2aWdhdGlvbi5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2NvbXBhdC9jb21wYXQtbmF2aWdhdGlvbi5jb21wb25lbnQudHMuQ29tcGF0TmF2aWdhdGlvbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxhcHAtY29tcGF0LW5hdmlnYXRpb24+PC9hcHAtY29tcGF0LW5hdmlnYXRpb24+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0FBO2dCQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/compat/compat-navigation.component.ngfactory.ts